import Spinner from '../common/Spinner';
import type { Subscription } from '../../types';

interface Props {
  eligible: boolean;
  status: Subscription['dedicated_ip_status'] | null;
  ip: string | null;
  onAddClick: () => void;
}

export default function DedicatedIpStatus({ eligible, status, ip, onAddClick }: Props) {
  if (status === 'active' && ip) {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs text-gray-600">
        <span className="w-2 h-2 rounded-full bg-green-500" />
        {ip}
      </span>
    );
  }

  if (status === 'provisioning') {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs text-gray-500">
        <Spinner size="sm" />
        Provisioning...
      </span>
    );
  }

  if (status === 'releasing') {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs text-gray-500">
        <Spinner size="sm" />
        Removing...
      </span>
    );
  }

  if (status === 'failed') {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs text-amber-600">
        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4.5c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
        </svg>
        IP issue — contact support
      </span>
    );
  }

  if (eligible && !status) {
    return (
      <button
        onClick={onAddClick}
        title="Add Dedicated IP Address"
        className="px-2 py-0.5 text-xs font-medium text-blue-600 border border-blue-300 rounded hover:bg-blue-50 transition-colors"
      >
        Add IP
      </button>
    );
  }

  return null;
}
